import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface Video {
  id: string;
  titulo: string;
  descricao: string;
  duracao: string;
  thumbnail: string;
  categoria: string;
  xp: number;
  assistido: boolean;
  url: string;
}

const ParticipanteTreinamento: React.FC = () => {
  const [categoriaAtiva, setCategoriaAtiva] = useState('todos');
  const [videoSelecionado, setVideoSelecionado] = useState<Video | null>(null);
  const [videosAssistidos, setVideosAssistidos] = useState<string[]>([]);

  const categorias = [
    { id: 'todos', label: 'Todos', icon: 'ri-play-circle-line' },
    { id: 'vendas', label: 'Vendas', icon: 'ri-shopping-cart-line' },
    { id: 'atendimento', label: 'Atendimento', icon: 'ri-customer-service-line' },
    { id: 'produtos', label: 'Produtos', icon: 'ri-box-3-line' },
    { id: 'lideranca', label: 'Liderança', icon: 'ri-team-line' }
  ];

  const videos: Video[] = [
    // Vendas
    {
      id: 'v1',
      titulo: 'Técnicas Avançadas de Vendas',
      descricao: 'Aprenda as melhores técnicas para aumentar suas vendas e conquistar mais clientes.',
      duracao: '15:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=professional%20sales%20training%20presentation%20modern%20office%20business%20people%20learning%20sales%20techniques%20bright%20clean%20background%20corporate%20style%20high%20quality%20realistic&width=400&height=225&seq=train-v1&orientation=landscape',
      categoria: 'vendas',
      xp: 150,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v2',
      titulo: 'Como Fechar Mais Negócios',
      descricao: 'Estratégias comprovadas para aumentar sua taxa de conversão e fechar mais vendas.',
      duracao: '12:45',
      thumbnail: 'https://readdy.ai/api/search-image?query=business%20deal%20closing%20handshake%20professional%20meeting%20room%20success%20celebration%20modern%20office%20bright%20lighting%20corporate%20environment&width=400&height=225&seq=train-v2&orientation=landscape',
      categoria: 'vendas',
      xp: 120,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v3',
      titulo: 'Prospecção Eficiente',
      descricao: 'Métodos modernos de prospecção para encontrar os clientes certos.',
      duracao: '18:20',
      thumbnail: 'https://readdy.ai/api/search-image?query=business%20prospecting%20professional%20using%20laptop%20searching%20clients%20modern%20workspace%20clean%20background%20focused%20person%20corporate%20style&width=400&height=225&seq=train-v3&orientation=landscape',
      categoria: 'vendas',
      xp: 180,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    // Atendimento
    {
      id: 'v4',
      titulo: 'Excelência no Atendimento',
      descricao: 'Como proporcionar uma experiência excepcional para seus clientes.',
      duracao: '14:15',
      thumbnail: 'https://readdy.ai/api/search-image?query=customer%20service%20excellence%20smiling%20professional%20helping%20client%20modern%20office%20friendly%20atmosphere%20bright%20clean%20background%20quality%20service&width=400&height=225&seq=train-v4&orientation=landscape',
      categoria: 'atendimento',
      xp: 140,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v5',
      titulo: 'Gestão de Reclamações',
      descricao: 'Transforme reclamações em oportunidades de fidelização.',
      duracao: '16:40',
      thumbnail: 'https://readdy.ai/api/search-image?query=professional%20handling%20customer%20complaint%20calm%20conversation%20office%20setting%20problem%20solving%20positive%20resolution%20clean%20modern%20environment&width=400&height=225&seq=train-v5&orientation=landscape',
      categoria: 'atendimento',
      xp: 160,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v6',
      titulo: 'Comunicação Assertiva',
      descricao: 'Desenvolva habilidades de comunicação clara e efetiva.',
      duracao: '13:25',
      thumbnail: 'https://readdy.ai/api/search-image?query=assertive%20communication%20training%20professional%20presentation%20business%20meeting%20clear%20speaking%20modern%20office%20bright%20clean%20background&width=400&height=225&seq=train-v6&orientation=landscape',
      categoria: 'atendimento',
      xp: 130,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    // Produtos
    {
      id: 'v7',
      titulo: 'Conhecimento de Produtos',
      descricao: 'Domine todos os detalhes dos nossos produtos e serviços.',
      duracao: '20:10',
      thumbnail: 'https://readdy.ai/api/search-image?query=product%20knowledge%20training%20professional%20presenting%20products%20display%20showcase%20modern%20retail%20environment%20clean%20bright%20background&width=400&height=225&seq=train-v7&orientation=landscape',
      categoria: 'produtos',
      xp: 200,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v8',
      titulo: 'Demonstração de Produtos',
      descricao: 'Técnicas para apresentar produtos de forma convincente.',
      duracao: '17:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=product%20demonstration%20professional%20showing%20features%20customer%20watching%20modern%20store%20clean%20bright%20environment%20engaging%20presentation&width=400&height=225&seq=train-v8&orientation=landscape',
      categoria: 'produtos',
      xp: 170,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v9',
      titulo: 'Lançamentos e Novidades',
      descricao: 'Fique por dentro dos últimos lançamentos e atualizações.',
      duracao: '11:50',
      thumbnail: 'https://readdy.ai/api/search-image?query=new%20product%20launch%20presentation%20modern%20technology%20innovation%20showcase%20professional%20event%20bright%20clean%20background%20exciting%20atmosphere&width=400&height=225&seq=train-v9&orientation=landscape',
      categoria: 'produtos',
      xp: 110,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    // Liderança
    {
      id: 'v10',
      titulo: 'Liderança Inspiradora',
      descricao: 'Como se tornar um líder que inspira e motiva sua equipe.',
      duracao: '19:45',
      thumbnail: 'https://readdy.ai/api/search-image?query=inspirational%20leadership%20training%20leader%20motivating%20team%20modern%20office%20group%20meeting%20positive%20energy%20bright%20clean%20environment&width=400&height=225&seq=train-v10&orientation=landscape',
      categoria: 'lideranca',
      xp: 190,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v11',
      titulo: 'Gestão de Equipes',
      descricao: 'Estratégias eficazes para gerenciar e desenvolver sua equipe.',
      duracao: '16:20',
      thumbnail: 'https://readdy.ai/api/search-image?query=team%20management%20training%20leader%20coordinating%20group%20modern%20office%20collaborative%20work%20bright%20clean%20background%20professional%20setting&width=400&height=225&seq=train-v11&orientation=landscape',
      categoria: 'lideranca',
      xp: 160,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    },
    {
      id: 'v12',
      titulo: 'Feedback Construtivo',
      descricao: 'Aprenda a dar e receber feedback de forma produtiva.',
      duracao: '14:35',
      thumbnail: 'https://readdy.ai/api/search-image?query=constructive%20feedback%20meeting%20professional%20conversation%20one%20on%20one%20discussion%20modern%20office%20positive%20atmosphere%20clean%20bright%20background&width=400&height=225&seq=train-v12&orientation=landscape',
      categoria: 'lideranca',
      xp: 140,
      assistido: false,
      url: 'https://www.youtube.com/embed/dQw4w9WgXcQ'
    }
  ];

  const videosFiltrados = categoriaAtiva === 'todos' 
    ? videos 
    : videos.filter(v => v.categoria === categoriaAtiva);

  const totalVideos = videos.length;
  const videosCompletos = videosAssistidos.length;
  const progressoGeral = Math.round((videosCompletos / totalVideos) * 100);
  const xpTotal = videos.reduce((acc, v) => acc + v.xp, 0);
  const xpGanho = videos.filter(v => videosAssistidos.includes(v.id)).reduce((acc, v) => acc + v.xp, 0);

  const marcarComoAssistido = (videoId: string) => {
    if (!videosAssistidos.includes(videoId)) {
      setVideosAssistidos([...videosAssistidos, videoId]);
    }
  };

  const videosRecomendados = videos
    .filter(v => v.id !== videoSelecionado?.id && !videosAssistidos.includes(v.id))
    .slice(0, 3);

  return (
    <div className="space-y-6 pb-20 lg:pb-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-teal-500 to-blue-600 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-2xl font-bold mb-2">🎓 Treinamentos</h1>
            <p className="text-teal-100">Assista aos vídeos e ganhe XP para evoluir na campanha</p>
          </div>
          <div className="hidden sm:block">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-graduation-cap-line text-4xl"></i>
            </div>
          </div>
        </div>

        {/* Estatísticas */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center gap-2 mb-1">
              <i className="ri-play-circle-line text-xl"></i>
              <span className="text-sm text-teal-100">Total de Vídeos</span>
            </div>
            <p className="text-2xl font-bold">{totalVideos}</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center gap-2 mb-1">
              <i className="ri-checkbox-circle-line text-xl"></i>
              <span className="text-sm text-teal-100">Assistidos</span>
            </div>
            <p className="text-2xl font-bold">{videosCompletos}</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center gap-2 mb-1">
              <i className="ri-star-line text-xl"></i>
              <span className="text-sm text-teal-100">XP Ganho</span>
            </div>
            <p className="text-2xl font-bold">{xpGanho}</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center gap-2 mb-1">
              <i className="ri-percent-line text-xl"></i>
              <span className="text-sm text-teal-100">Progresso</span>
            </div>
            <p className="text-2xl font-bold">{progressoGeral}%</p>
          </div>
        </div>

        {/* Barra de Progresso Geral */}
        <div className="mt-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-teal-100">Progresso Geral</span>
            <span className="text-sm font-bold">{videosCompletos}/{totalVideos} vídeos</span>
          </div>
          <div className="h-3 bg-white/20 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full transition-all duration-500"
              style={{ width: `${progressoGeral}%` }}
            ></div>
          </div>
        </div>
      </div>

      {/* Filtros de Categoria */}
      <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-200">
        <div className="flex items-center gap-2 overflow-x-auto pb-2">
          {categorias.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setCategoriaAtiva(cat.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all whitespace-nowrap ${
                categoriaAtiva === cat.id
                  ? 'bg-gradient-to-r from-teal-500 to-blue-600 text-white shadow-md'
                  : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
            >
              <i className={`${cat.icon} text-lg`}></i>
              <span>{cat.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Grid de Vídeos */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videosFiltrados.map((video) => {
          const foiAssistido = videosAssistidos.includes(video.id);
          
          return (
            <div
              key={video.id}
              className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-lg transition-all hover:-translate-y-1 cursor-pointer"
              onClick={() => setVideoSelecionado(video)}
            >
              {/* Thumbnail */}
              <div className="relative w-full h-48 bg-slate-100">
                <img
                  src={video.thumbnail}
                  alt={video.titulo}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-center justify-center">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-3xl text-teal-600"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3 bg-black/70 backdrop-blur-sm px-2 py-1 rounded-lg text-white text-xs font-semibold">
                  {video.duracao}
                </div>
                {foiAssistido && (
                  <div className="absolute top-3 left-3 bg-green-500 px-2 py-1 rounded-lg text-white text-xs font-semibold flex items-center gap-1">
                    <i className="ri-check-line"></i>
                    Assistido
                  </div>
                )}
              </div>

              {/* Conteúdo */}
              <div className="p-4">
                <div className="flex items-start justify-between mb-2">
                  <h3 className="font-bold text-slate-900 flex-1 line-clamp-2">{video.titulo}</h3>
                  <div className="flex items-center gap-1 text-yellow-600 ml-2">
                    <i className="ri-star-fill"></i>
                    <span className="text-sm font-bold">{video.xp}</span>
                  </div>
                </div>
                <p className="text-sm text-slate-600 line-clamp-2 mb-3">{video.descricao}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-teal-600 bg-teal-50 px-2 py-1 rounded-full">
                    {categorias.find(c => c.id === video.categoria)?.label}
                  </span>
                  {foiAssistido && (
                    <span className="text-xs text-green-600 font-medium flex items-center gap-1">
                      <i className="ri-checkbox-circle-fill"></i>
                      Completo
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal de Vídeo */}
      {videoSelecionado && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setVideoSelecionado(null)}>
          <div className="bg-slate-900 rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="sticky top-0 bg-slate-900 border-b border-slate-700 p-4 flex items-center justify-between z-10">
              <h2 className="text-xl font-bold text-white">{videoSelecionado.titulo}</h2>
              <button
                onClick={() => setVideoSelecionado(null)}
                className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-slate-800 transition-colors"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
            </div>

            {/* Player de Vídeo */}
            <div className="relative w-full bg-black" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src={videoSelecionado.url}
                title={videoSelecionado.titulo}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            {/* Informações do Vídeo */}
            <div className="p-6 space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-sm font-semibold text-teal-400 bg-teal-500/20 px-3 py-1 rounded-full">
                      {categorias.find(c => c.id === videoSelecionado.categoria)?.label}
                    </span>
                    <span className="text-sm text-slate-400 flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {videoSelecionado.duracao}
                    </span>
                    <span className="text-sm text-yellow-400 flex items-center gap-1">
                      <i className="ri-star-fill"></i>
                      {videoSelecionado.xp} XP
                    </span>
                  </div>
                  <p className="text-slate-300">{videoSelecionado.descricao}</p>
                </div>
              </div>

              {/* Botão Marcar como Assistido */}
              {!videosAssistidos.includes(videoSelecionado.id) ? (
                <button
                  onClick={() => marcarComoAssistido(videoSelecionado.id)}
                  className="w-full px-6 py-3 bg-gradient-to-r from-teal-500 to-blue-600 text-white rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap"
                >
                  <i className="ri-check-line mr-2"></i>
                  Marcar como Assistido
                </button>
              ) : (
                <div className="w-full px-6 py-3 bg-green-500/20 border-2 border-green-500 text-green-400 rounded-lg font-semibold text-center">
                  <i className="ri-checkbox-circle-fill mr-2"></i>
                  Vídeo Assistido - +{videoSelecionado.xp} XP
                </div>
              )}

              {/* Vídeos Recomendados */}
              {videosRecomendados.length > 0 && (
                <div className="pt-4 border-t border-slate-700">
                  <h3 className="text-lg font-bold text-white mb-4">Próximos Vídeos</h3>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {videosRecomendados.map((video) => (
                      <button
                        key={video.id}
                        onClick={() => setVideoSelecionado(video)}
                        className="bg-slate-800 rounded-lg overflow-hidden hover:bg-slate-700 transition-colors text-left"
                      >
                        <div className="relative w-full h-32 bg-slate-700">
                          <img
                            src={video.thumbnail}
                            alt={video.titulo}
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                            <i className="ri-play-fill text-2xl text-white"></i>
                          </div>
                          <div className="absolute bottom-2 right-2 bg-black/70 px-2 py-0.5 rounded text-white text-xs font-semibold">
                            {video.duracao}
                          </div>
                        </div>
                        <div className="p-3">
                          <h4 className="text-sm font-semibold text-white line-clamp-2 mb-1">{video.titulo}</h4>
                          <div className="flex items-center gap-2">
                            <span className="text-xs text-yellow-400 flex items-center gap-1">
                              <i className="ri-star-fill"></i>
                              {video.xp}
                            </span>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticipanteTreinamento;
